import React from 'react';
import cryingBearImage from '@/assets/app/images/common/bottom/crying-bear.png';
import AppButton from '@/shared/components/ui/new/AppButton';

interface ExitQuizModalProps {
  onConfirm: () => void;
  onCancel: () => void;
  sessionId: number;
  closeSheet: () => void;
}

export const ExitQuizSheet: React.FC<ExitQuizModalProps> = ({
  onConfirm,
  onCancel,
  sessionId,
  closeSheet,
}) => {
  const exitQuiz = () => {
    closeSheet();
    onCancel();
  };
  return (
    <div className="pt-6 pb-2 space-y-4">
      {/* 캐릭터 이미지 */}
      <div className="flex justify-center">
        <img src={cryingBearImage} alt="울고있는 캐릭터" />
      </div>

      {/* 메시지 */}
      <h2 className="text-xl font-bold text-[800] text-center f-one-pop" style={{ fontSize: 26 }}>
        모험을 종료할까요?
      </h2>
      <div className="text-center" style={{ color: '#6C6C6C', fontSize: 16 }}>
        지금 종료하면 모험이 초기화 되며
        <br />
        소모된 별 포인트는 사라져요
      </div>

      <div className="button-group" style={{ marginTop: 20 }}>
        <AppButton className="f-one-pop text-[20px]" onConfirm={onConfirm} message="계속 하기" />
        <AppButton
          backgroundColor="#D4D4D4"
          boxShadowColor="#B7B7B7"
          style={{
            marginTop: 10,
          }}
          className="f-one-pop text-[20px]"
          onConfirm={exitQuiz}
          message="모험 종료"
        />
      </div>
    </div>
  );
};
